import { render, staticRenderFns } from "./photo-cornea.vue?vue&type=template&id=1d0f129c&scoped=true&"
import script from "./photo-cornea.vue?vue&type=script&lang=js&"
export * from "./photo-cornea.vue?vue&type=script&lang=js&"
import style0 from "./photo-cornea.vue?vue&type=style&index=0&id=1d0f129c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0f129c",
  null
  
)

export default component.exports